import React from 'react';
import classNames from 'classnames';
import './index.scss';

export interface IFilterButton {
  id: string;
  name: string;
  selected: boolean;
}

interface IFilterButtonProps {
  filters: IFilterButton[];
  onFilter: (id: string, futureState: boolean) => void;
}

const FilterButtons: React.FC<IFilterButtonProps> = props => {
  const { onFilter, filters } = props;

  return (
    <div className="filter_button_container" role="group">
      {filters.map(filter => {
        return (
          <button
            key={filter.id}
            role="button"
            className={classNames('filter_button', { selected: filter.selected })}
            onClick={() => onFilter(filter.id, !filter.selected)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // don't scroll if spacebar is pressed
                onFilter(filter.id, !filter.selected);
              }
            }}
          >
            {filter.name}
          </button>
        );
      })}
    </div>
  );
};

export default FilterButtons;
